import React, { useEffect, useMemo, useState } from "react"
import { useAllReportsContext } from "../contextProviders/allReportsContext"
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap"
import { dataSource } from "../../../services/dataSource"
import { ARCH, REP, REP_V2 } from "../../../shared/Data/typeDirs"
import ButtonWithLoadSpinner from "../../../components/buttonWithLoadSpinner"
import ReactTable from "react-table"
import { DateToFormattedString } from "../../../shared/utils"
import { useNotificationContext } from "../contextProviders/notificationContext"
import { deleteDropboxFile } from "../../../services/dropboxRequests"
import { useUserContext } from "../contextProviders/userContext"
import DataTable from "../../dataTable"

const ARCHIVE_ACTIONS = [
  { name: 'archive', label: 'Archive', func: archive },
  { name: 'unarchive', label: 'Unarchive', func: unarchive },
  { name: 'delete', label: 'Delete', func: obliterate },
  { name: 'delete_data', label: 'Delete Data Only', func: kill }
]

const ARCHIVE_TYPES = [{ name: REP_V2, label: 'Reports V2' }]


const cols = [
  { Header: "Name", accessor: 'name', minWidth: 220 },
  { Header: "Modified", accessor: 'modified', minWidth: 100 },
  { Header: "Vers.", accessor: 'version', minWidth: 50 },
  {
    Header: "Date Created", accessor: 'created', Cell: rowinfo => {
      // console.log('making created cell', rowinfo)
      return (
        <div>
          {DateToFormattedString(new Date(rowinfo.row.original.created))}
        </div>
      )
    }
  }
]


export function ArchiveController() {
  let { initAllData: getAllReports, ...restData } = useAllReportsContext()
  let { user } = useUserContext()
  let displayNotif = useNotificationContext()
  const [state, setState] = useState({
    filter: ''
  })
  let [type, setType] = useState(REP_V2)

  useEffect(() => {
    if (state.allArchivedReports) return
    let stillAlive = true
    setTimeout(async () => {
      let allArchivedReports = await dataSource('remDb')[type].toFlatArray('Archive')
      console.log('got archived reports', stillAlive, allArchivedReports)
      if (stillAlive) setState({ ...state, allArchivedReports })
    })
    return () => { stillAlive = false }
  }, [state])


  const allReports = useMemo(() => restData[type], [type, restData])
  let selectedAction = useMemo(() => {
    return state.selectedActionIdx || state.selectedActionIdx === 0 ? ARCHIVE_ACTIONS[state.selectedActionIdx] : ARCHIVE_ACTIONS[0]
  }, [state.selectedActionIdx])

  // const finishedArchiveCallback = useMemo(()=>{
  //   return selectedAction.name === 'archive' ? getAllReports : initAllArchivedReports
  // })

  const docList = useMemo(()=>selectedAction.name !== 'unarchive' ? allReports : state.allArchivedReports, [allReports, state.allArchivedReports, selectedAction])
  const filteredDocList = useMemo(() => {
    console.log('making filtered doc list', allReports, state.filter)
    return docList && docList.filter(rep => rep.name && rep.name.toLowerCase().includes(state.filter.toLowerCase()))
  }, [state.filter, allReports, docList])

  let selectedDoc = useMemo(() => {
    return state.selectedDocIdx || state.selectedDocIdx === 0 ? filteredDocList[state.selectedDocIdx] : false
  }, [state.selectedDocIdx, filteredDocList])



  console.log('got these memoized vars', selectedDoc, state.selectedDocIdx, selectedAction, filteredDocList)
  return (
    <div >
      <div className="db-conman-area" style={{ width: '50%' }}>
        <Dropdown onSelect={(eventKey) => setState({ ...state, selectedActionIdx: eventKey })}>
          <Dropdown.Toggle variant="activated">
            {selectedAction.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {ARCHIVE_ACTIONS.map((action, idx) => (<Dropdown.Item key={idx} eventKey={idx}>{action.label}</Dropdown.Item>))}
          </Dropdown.Menu>
        </Dropdown>
        {/* <Dropdown onSelect={(eventKey) => setType(eventKey)}>
          <Dropdown.Toggle variant="activated">
            {type}
          </Dropdown.Toggle>
          <Dropdown.Menu>{ARCHIVE_TYPES.map(itm => <Dropdown.Item key={itm.name} eventKey={itm.name}>{itm.label}</Dropdown.Item>)}</Dropdown.Menu>
        </Dropdown> */}
        <ButtonWithLoadSpinner
          disabled={!selectedDoc}
          onClick={async () => {
            console.log('executing archive func', selectedAction, selectedDoc)
            // return
            try {
              await selectedAction.func(selectedDoc, type, user.token)
              setState({ ...state, selectedDocIdx: false })
              displayNotif('success', `Successfully executed ${selectedAction.label} for ${selectedDoc.name}`)
              let allArchivedReports = await dataSource('remDb')[type].toFlatArray('Archive')
              console.log('got archived reports', allArchivedReports)
              setState({ ...state, allArchivedReports })
              return await getAllReports()

            } catch (error) {
              console.log('failed action', selectedAction.name, error)
              displayNotif('danger', `Failed ${selectedAction.label} for ${selectedDoc.name}: ${error.message}`)
            }
            // return finishedArchiveCallback()
            // return selectedAction.func(selectedDoc)
          }}
          variant='danger'
        >
          {selectedAction.label}
        </ButtonWithLoadSpinner>
      </div>
      <div>
        <div>
          <Row >
            <Col sm={10}>
              <Form.Control type="text" placeholder="Search Reports" onChange={evt => {
                setState({ ...state, filter: evt.target.value, selectedDocIdx: false })
              }} />
            </Col>
          </Row>
          {filteredDocList && filteredDocList.length ? (
            <DataTable
              data={filteredDocList}
              cols={cols}
              minRows={10}
              defaultPageSize={10}
              showPagination={true}
              loading={state.loading}
              selectedIdx={state.selectedDocIdx}
              onClick={(rowInfo, rowIndex) => {
                console.log('clicked row item', rowIndex, rowInfo)
                setState({ ...state, selectedDocIdx: filteredDocList.findIndex((itm)=>rowInfo._id === itm._id) })
              }}
              getRowStyle={(rowInfo) => {
                if(rowInfo._id === selectedDoc._id) console.log('getting row style for row', rowInfo)
                return rowInfo._id === selectedDoc._id ? {
                  backgroundColor: '#CADDDD'
                } : {}
              }}
              className="-striped -highlight" />) : []}
        </div>
      </div>
    </div>
  )
}

async function archive(doc, type) {

  console.log('about to archive', doc)
  return dataSource('remDb')[type].archive({ _id: doc._id, name: doc.name })
}

async function unarchive(doc, type) {
  console.log('about to unarchive', doc)
  return dataSource('remDb')[type].unarchive({ _id: doc._id, name: doc.name })
}

async function kill(doc, type) {
  console.log('about to kill', doc)
  return dataSource('remDb')[type].kill({ _id: doc._id, name: doc.name })
}

async function obliterate(doc, type, token) {
  console.log('about to obliterate', doc)
  await dataSource('remDb')[type].kill({ _id: doc._id, name: doc.name })
  try {
    await deleteDropboxFile(`/Archive/${type}/${doc.dirName}`, token)
  } catch (e) {
    console.error(e)
  }

}